export { Column as default } from 'fixed-data-table-2';
